import { Col, FormGroup, Input, Label } from "reactstrap";
import { H6, Image, LI, UL } from "../../../../AbstractElements";
import { ChooseBanks } from "../../../../Constant";
import { POPULER_BANK_LIST } from "../../../../Data/FormLayout";
import { useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { BankLogoListProp } from "../../../../Type/FormLayoutType";

export const BankLogoList = ({ getUserData }: BankLogoListProp) => {
  const { bankDetailsForm } = useAppSelector((state) => state.formWizardTwo);
  const { bankName } = bankDetailsForm;
  
  return (
    <Col xs="12">
      <H6>{ChooseBanks}</H6>
      <div className="bank-selection">
        <FormGroup check className="radio radio-primary ps-0">
          <UL className="simple-list radio-wrapper d-flex flex-row mb-3">
            {POPULER_BANK_LIST.map((data, index) => (
              <LI key={index}>
                <Input id={data.bankName} type="radio" name="bankName" value={data.bankName} checked={bankName === data.bankName} onChange={getUserData} />
                <Label className="form-check-label" htmlFor={data.bankName} check>
                  <Image src={dynamicImage(`forms/${data.imageName}`)} alt={data.bankName} />
                  <span>{data.bankName}</span>
                </Label>
              </LI>
            ))}
          </UL>
        </FormGroup>
      </div>
    </Col>
  );
};
